import * as yup from 'yup';
import { Form, FieldGroup, FieldLabel, FieldError, TextArea, ButtonGroup, } from './styles';
import React from 'react';
import Button from 'src/Components/Common/AdminButton/Button';
import { ROUTES } from '../../Utils/constants';
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useBuildingOptions } from '../../Utils/hooks/useBuildingOptions';
import { useApartmentOptions } from '../../Utils/hooks/useApartmentOptions';
import { useHistory } from 'react-router-dom';
import { getSearchParams } from 'src/Utils/getQueryParams';
import { useTowerOptions } from 'src/Utils/hooks/useTowerOptions';
import SearchableSelect from '../Common/SearchableSelect/SearchableSelect';
var validationSchema = yup
    .object({
    message: yup.string().min(1, 'El mensaje es requerido').required(),
    building_id: yup
        .number()
        .typeError('El edificio es requerido')
        .positive()
        .required(),
    tower_id: yup.number().defined().nullable(),
    apartment_id: yup
        .number()
        .transform(function (value) { return (value === -1 ? null : value); })
        .positive()
        .nullable(),
})
    .required();
function TicketAlertForm(_a) {
    var _b, _c, _d, _e, _f, _g;
    var propsBuildingId = _a.buildingId, ticketAlert = _a.ticketAlert, onSubmit = _a.onSubmit;
    var history = useHistory();
    var _h = useForm({
        defaultValues: ticketAlert
            ? {
                building_id: ticketAlert.building.id,
                tower_id: (_b = ticketAlert.apartment) === null || _b === void 0 ? void 0 : _b.tower_id,
                apartment_id: (_c = ticketAlert.apartment) === null || _c === void 0 ? void 0 : _c.id,
                message: ticketAlert.message,
            }
            : {
                building_id: propsBuildingId,
                apartment_id: null,
                message: '',
            },
        resolver: yupResolver(validationSchema),
    }), handleSubmit = _h.handleSubmit, _j = _h.formState, errors = _j.errors, isSubmitting = _j.isSubmitting, control = _h.control, watch = _h.watch, setValue = _h.setValue;
    var buildingId = watch('building_id');
    var towerId = watch('tower_id');
    var _k = useBuildingOptions(), isLoadingBuildings = _k.isLoading, buildingOptions = _k.buildingOptions;
    var _l = useTowerOptions({
        buildingId: buildingId,
        resetTowerSelect: function () { return setValue('tower_id', null); },
    }), isLoadingTowers = _l.isLoading, towerOptions = _l.towerOptions;
    var _m = useApartmentOptions({
        buildingId: buildingId,
        towerId: towerId,
        resetApartmentsSelect: function () { return setValue('apartment_id', null); },
    }), isLoadingApartments = _m.isLoading, apartmentOptions = _m.apartmentOptions;
    var handleCancel = function () {
        var searchParams = getSearchParams({ building_id: buildingId });
        history.push(ROUTES.alertas_tickets + (searchParams ? "?" + searchParams : ''));
    };
    var isFormDisabled = isLoadingBuildings ||
        isLoadingTowers ||
        isLoadingApartments ||
        isSubmitting;
    return (React.createElement(Form, { onSubmit: handleSubmit(onSubmit) },
        React.createElement(FieldGroup, null,
            React.createElement(FieldLabel, null, "Edificio"),
            React.createElement(Controller, { defaultValue: null, name: "building_id", control: control, render: function (field) { return (React.createElement(SearchableSelect, { value: isLoadingBuildings ? null : field.value, onChange: field.onChange, options: buildingOptions, disabled: isFormDisabled })); } }),
            React.createElement(FieldError, null, (_d = errors.building_id) === null || _d === void 0 ? void 0 : _d.message)),
        React.createElement(FieldGroup, null,
            React.createElement(FieldLabel, null, "Torre"),
            React.createElement(Controller, { defaultValue: null, name: "tower_id", control: control, render: function (field) { return (React.createElement(SearchableSelect, { value: isLoadingTowers ? null : field.value, onChange: field.onChange, options: towerOptions, disabled: isFormDisabled || !buildingId, clearable: true })); } }),
            React.createElement(FieldError, null, (_e = errors.building_id) === null || _e === void 0 ? void 0 : _e.message)),
        React.createElement(FieldGroup, null,
            React.createElement(FieldLabel, null, "Apartamento"),
            React.createElement(Controller, { defaultValue: null, name: "apartment_id", control: control, render: function (field) { return (React.createElement(SearchableSelect, { value: isLoadingApartments ? null : field.value, onChange: field.onChange, options: apartmentOptions, disabled: isFormDisabled || !towerId, clearable: true })); } }),
            React.createElement(FieldError, null, (_f = errors.apartment_id) === null || _f === void 0 ? void 0 : _f.message)),
        React.createElement(FieldGroup, null,
            React.createElement(FieldLabel, { htmlFor: "message" }, "Mensaje"),
            React.createElement(Controller, { control: control, name: "message", render: function (field) { return (React.createElement(TextArea, { value: field.value, onChange: field.onChange, id: "message", disabled: isFormDisabled })); } }),
            React.createElement(FieldError, null, (_g = errors.message) === null || _g === void 0 ? void 0 : _g.message)),
        React.createElement(ButtonGroup, null,
            React.createElement(Button, { className: "white", type: "button", onClick: handleCancel }, "Cancelar"),
            React.createElement(Button, { disabled: isFormDisabled, type: "submit" }, "Guardar"))));
}
export default TicketAlertForm;
